import { axios, Response } from '../index'
import { GetAdminResponse } from './get-admins'

const editAdmin = (
  adminAppUserId: number,
  accessProfileId: number
): Response<GetAdminResponse> => {
  return axios.put(`/v1/admins/${adminAppUserId}/${accessProfileId}`)
}

export default editAdmin
